export enum VossVersionStatus {
    Draft = 0,
    Staged = 1,
    Published = 2,
    Archived = 3,
    Discarded = 4,
}

export const VossVersionStatusText: Record<VossVersionStatus, string> = {
    [VossVersionStatus.Draft]: 'Draft',
    [VossVersionStatus.Staged]: 'Staged',
    [VossVersionStatus.Published]: 'Published',
    [VossVersionStatus.Archived]: 'Archived',
    [VossVersionStatus.Discarded]: 'Discarded',
};

export const versionStatuses = Object.keys(VossVersionStatusText).map(Number) as VossVersionStatus[];

// VOSS names the status in some payloads (StringEnumConverter) and numbers it in others
export const versionStatusName = (status: VossVersionStatus): string => VossVersionStatusText[status];

export const versionStatusFromName = (name: string | null | undefined): VossVersionStatus | undefined =>
    name === null || name === undefined ? undefined : versionStatuses.find((status) => VossVersionStatusText[status] === name);
